import { ExpandMore } from '@mui/icons-material';
import {
  AccordionDetails,
  AccordionProps,
  AccordionSummary,
  AccordionSummaryProps,
  Accordion as MuiAccordion,
  Theme
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { FC } from 'react';

const StyledAccordion = styled(MuiAccordion)(({ theme }: { theme: Theme }) => ({
  '& .MuiAccordionSummary-root': {
    background: '#fff',
    minHeight: 'fit-content',
    borderTop: '3px solid ' + theme.palette.primary.main
  },
  '& .MuiAccordionSummary-content': {
    color: theme.palette.secondary.contrastText,
    textTransform: 'uppercase',
    margin: 0
  },
  '& .MuiAccordionSummary-expandIconWrapper': {
    color: theme.palette.primary.main
  },
  '& .MuiCollapse-root': {
    background: '#fff'
  },
  '& .MuiAccordionDetails-root': {
    padding: 16
  }
}));

const Accordion: FC<AccordionProps & { summaryProps?: AccordionSummaryProps }> = ({
  title,
  children,
  summaryProps,
  ...props
}) => (
  <StyledAccordion defaultExpanded elevation={0} key={title} {...props}>
    <AccordionSummary expandIcon={<ExpandMore color="inherit" fontSize="large" />} {...summaryProps}>
      <h3 className="font-weight-regular">{title}</h3>
    </AccordionSummary>
    <AccordionDetails>{children}</AccordionDetails>
  </StyledAccordion>
);

export default Accordion;
